export default {
  Titleemail: 'Email',
  password: 'Password',
  EmailConfirmation: ' Email Confirmation',
  Confirm_Password: 'Confirm Password',
  Document_type: 'Document type',
  Identification_document: 'Identification document',
  name: 'Name',
  First_last_name: 'First last name',
  Second_last_name: 'Second last name',
  occupation: 'Occupation',
  state: 'State',
  Municipality: 'Municipality',
  Sector: 'Sector',
  Telephone_contact: 'Telephone contact',
  Secondary_contact_phone: 'Secondary contact phone',
  Address: 'Address',
  conditions: 'I accept the terms and conditions of use and privacy',
  Back: 'Back',
  Continue: 'Continue',
  Register: 'Register',
  Registro_ciudadano: ' Citizen Registration',


  myText: [
    {

      text: "my book"
    },
    {

      text: "my text2"
    }
  ],
  RegisterSteps: [
    {
      title: 'Authentication Information',
      //title: i18next.t('register'),
      elements: [
        'email',
        'emailConfirmation',
        'password',
        'password_confirmation'
      ]
    },
    {
      title: 'Personal information',
      elements: [
        'document_type',
        'citizen_id',
        'name',
        'first_last_name',
        'second_last_name',
        'occupation',
        'province_id',
        'municipality_id',
        'sector_id',
        'phone',
        'phone2',
        'email2',
        'address'
      ]
    },
    {
      title: 'Terms and Conditions',
      elements: [
        'termsAndCondition'
      ]
    },
    {
      title: 'Account activation'
    },
  ],

}





